import React, { createContext, useCallback, useState } from "react";
import { mergeDelete } from "utils/payload.utils";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type) => {
    const toast = { id: Date.now() * Math.random(), message, type };

    setToasts((currentToasts) => [...currentToasts, toast]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((currentToasts) => mergeDelete(currentToasts, id, "id"));
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, showToast, removeToast }}>
      {children}
    </ToastContext.Provider>
  );
};
